import { render, staticRenderFns } from "./CompareTableViewpoints.vue?vue&type=template&id=190d145e&scoped=true&"
import script from "./CompareTableViewpoints.vue?vue&type=script&lang=ts&"
export * from "./CompareTableViewpoints.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTableViewpoints.vue?vue&type=style&index=0&id=190d145e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d145e",
  null
  
)

export default component.exports